import TextInput from "components/form/input/TextInput";
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import ADO from "..";

export function ParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields 
            name={ADO.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Intervalo de Aderência">
                        <TextInput name="intervaloMin" label="Mínimo"  type="number"  />
                        <TextInput name="intervaloMax" label="Máximo" type="number"  />
                    </ParamFormRow>

                    <ParamFormRow label="Metros Lineares por Amostra">
                        <TextInput name="metrosLinearesAmostra" label="Valor (Metros)" type="number"  />
                    </ParamFormRow>

                    <ParamFormRow label="Metros Lineares por Hectare">
                        <TextInput name="metrosLinearesHectare" label="Valor (Metros)" type="number"  />
                    </ParamFormRow>

                    <ParamFormRow label="Meta">
                        <TextInput name="meta" label="Meta (%)"  type="number" />
                    </ParamFormRow>
                </>
            }
        />
    );
}
